export interface ApiResponse {
  Result: Result[];
  QueryId: string;
  ElapsedMilliseconds: number;
  QueryDate?: string;
  Status: Status;

  Evidences?: Evidences;
}

export interface BigDataCorpResponse {}

export interface Result {
  MatchKeys: string;
  GovernmentDebtors?: GovernmentDebtors;
  Lawsuits?: Lawsuits;
  LawsuitsDistributionData?: LawsuitsDistributionData;
  OnlineCertificates?: OnlineCertificate[];
  ComprotProcesses?: ComprotProcesses;
  PerDecomp?: PerDecomp[];
}

export enum PerdcompTipoDocumento {
  DeclaracaoDeCompensacao = "Declaração de Compensação",
  PedidoDeRessarcimento = "Pedido de Ressarcimento",
  PedidoDeRestituicao = "Pedido de Restituição",
  PedidodeReembolso = "Pedido de Reembolso",
  PedidoDeCancelamento = "Pedido de Cancelamento",
}

export enum PerdcompTipoCredito {
  PagamentoIndevidoOuAMaior = "Pagamento Indevido ou a Maior",
  RessarcimentoDeIPI = "Ressarcimento de IPI",
  CofinsNaoCumulativa = "Cofins Não-Cumulativa - Ressarcimento/Compensação",
  PISPASEPNaoCumulativo = "PIS/PASEP Não-Cumulativo - Ressarcimento/Compensação",
  OutrosCreditos = "Outros Créditos",
  ContribuicaoPrevidenciariaIndevidaOuAMaior = "Contribuição Previdenciária Indevida ou a Maior",
  SaldoNegativoDeCSLL = "Saldo Negativo de CSLL",
  SaldoNegativoDeIRPJ = "Saldo Negativo de IRPJ",
  SalarioFamiliaSalarioMaternidade = "Salário-Família / Salário-Maternidade",
}

export enum PerdcompSituacao {
  EmAnalise = "Em análise ",
}

export interface PerDecomp {
  numeroPerdcomp: string;
  tipoDocumento: string;
  tipoCredito: string;
  dataTransmissao: string;
  situacao: string;
  descricaoSituacao: string;
  contribuinte: Contribuinte;
}

export interface Login {
  Code: number;
  Message: string;
}

export interface Contribuinte {
  ni: string;
  nome: string;
}

export interface GovernmentDebtors {
  DebtorName: string;
  TotalDebtValue: number;
  TotalDebtValuePerOrigin: TotalDebtValuePerOrigin;
  TotalDebts: number;
  TotalDebtsPerOrigin: TotalDebtsPerOrigin;
  Debts: Debt[];
}

export interface TotalDebtValuePerOrigin {
  "SIDA/ Receita da dívida ativa - CSLL": number;
  "SIDA/ Receita da dívida ativa - IRPJ": number;
  "SIDA/ Receita da dívida ativa - PIS": number;
  "SIDA/ Receita da dívida ativa - COFINS": number;
}

export interface TotalDebtsPerOrigin {
  "SIDA/ Receita da dívida ativa - CSLL": number;
  "SIDA/ Receita da dívida ativa - IRPJ": number;
  "SIDA/ Receita da dívida ativa - PIS": number;
  "SIDA/ Receita da dívida ativa - COFINS": number;
}

export interface Debt {
  Source: string;
  DebtOrigin: string;
  ConsolidatedValue: number;
  DebtorType: string;
  ResponsibleUnity: string;
  ResponsibleUnityUF: string;
  RegistrationNumber: string;
  RegistrationSituationType: string;
  RegistrationSituation: string;
  FiledIndicator: boolean;
  RegistrationDate: string;
  CreationDate: string;
  LastUpdateDate: string;
}

export interface Lawsuits {
  Lawsuits: Lawsuit[];
  TotalLawsuits: number;
  TotalLawsuitsAsAuthor: number;
  TotalLawsuitsAsDefendant: number;
  TotalLawsuitsAsOther: number;
  FirstLawsuitDate: string;
  LastLawsuitDate: string;
  Last30DaysLawsuits: number;
  Last90DaysLawsuits: number;
  Last180DaysLawsuits: number;
  Last365DaysLawsuits: number;
}

export interface Lawsuit {
  Number: string;
  Type: string;
  MainSubject: string;
  CourtName: string;
  CourtLevel: string;
  CourtType: string;
  CourtDistrict: string;
  JudgingBody: string;
  State: string;
  Status: string;
  LawsuitHostService: string;
  InferredCNJSubjectName: string;
  InferredCNJSubjectNumber: number;
  InferredCNJProcedureTypeName: string;
  InferredBroadCNJSubjectName: string;
  InferredBroadCNJSubjectNumber: number;
  OtherSubjects: string[];
  NumberOfVolumes: number;
  NumberOfPages: number;
  Value: number;
  ResJudicataDate: string;
  CloseDate: string;
  RedistributionDate: string;
  PublicationDate: string;
  NoticeDate: string;
  LastMovementDate: string;
  CaptureDate: string;
  LastUpdate: string;
  NumberOfParties: number;
  NumberOfUpdates: number;
  LawSuitAge: number;
  AverageNumberOfUpdatesPerMonth: number;
  ReasonForConcealedData: number;
  Parties: Party[];
  Updates: Update[];
  Petitions: any[];
  Decisions: any[];
}

export interface Party {
  Doc: string;
  IsPartyActive: boolean;
  Name: string;
  Polarity: string;
  Type: string;
  IsInference: boolean;
  PartyDetails: PartyDetails;
  LastCaptureDate: string;
}

export interface PartyDetails {
  OAB: string;
  State: string;
  SpecificType: string;
}

export interface Update {
  Content: string;
  PublishDate: string;
  CaptureDate: string;
}

export interface LawsuitsDistributionData {}

export interface OnlineCertificate {
  Origin: string;
  AdditionalOutputData: AdditionalOutputData;
}

export interface AdditionalOutputData {
  [key: string]: any;
}

export interface ComprotProcesses {
  TotalNumberOfProcesses: number;
  TotalNumberOfMovements: number;
  FirstMovementDate: string;
  LastMovementDate: string;
  RawResultFile: string;
  RawResultFileType: string;
}

export interface Status {
  perdecomp?: string;
  government_debtors?: GovernmentDebtor[];
  processes?: Process[];
  lawsuits_distribution_data?: LawsuitsDistributionDaum[];
  ondemand_public_projects?: OndemandPublicProject[];
  ondemand_comprot_processes?: OndemandComprotProcess[];
  login?: Login[];
}

export interface GovernmentDebtor {
  Code: number;
  Message: string;
}

export interface Process {
  Code: number;
  Message: string;
}

export interface LawsuitsDistributionDaum {
  Code: number;
  Message: string;
}

export interface OndemandPublicProject {
  Code: number;
  Message: string;
}

export interface OndemandComprotProcess {
  Code: number;
  Message: string;
}

export interface Evidences {}
